<component :is="tag" v-bind="attributesPrep" @click="handleClick" class="form-ii" ref="button">
    <span v-if="preloader" class='icon rotate'></span>
	<span v-if="label" class="btn-inner" v-html="label"></span>
	<span class="btn-inner" style="position: relative;"><slot name="left"></slot></span>
	<span class="btn-inner" style="position: relative;"><slot name="center"></slot></span>
	<span class="btn-inner" style="position: relative;"><slot name="right"></slot></span>
</component>
